import {
  Arrange,
  Container,
  Icon,
  Spacer,
  SvgClock,
  SvgEye,
  Text,
  Tooltip,
} from '@loomhq/lens';
import pluralize from 'pluralize';
import React from 'react';
import { useSelector } from 'react-redux';

import { LOOM_URI } from 'constants/routes';
import { getCloudfrontURI } from 'utilities/avatar';
import { secondsToHumanReadableString } from 'utilities/time';
import { goToNewTab } from 'utilities/url';

import { selectVideo, selectVideoDuration } from 'selectors/videoPlayer';

import { limit } from '../formatting';

import { EmbedContext } from 'components/embed-video';
import UserAvatar from 'components/user-avatar';

import styles from './styles.module.less';

const limitTo20Characters = limit(20);

const EmbedTitleAuthor = () => {
  const video = useSelector(selectVideo);
  const ownerName = video?.owner_full_name;
  const avatar = video?.owner_avatar?.thumb;
  const duration = Math.floor(useSelector(selectVideoDuration));

  const showViews = Boolean(video.views);
  const viewCount = video.views?.total;

  const shareUrl = `${LOOM_URI}/share/${video.id}`;

  const titleClick = () => {
    goToNewTab(shareUrl);
  };

  return (
    <EmbedContext.Consumer>
      {({ hideOwner, hideTitle }) => (
        <div>
          <Container
            paddingX="small"
            radius="medium"
            backgroundColor="var(--videoOverlay)"
          >
            <Arrange height={4.5} gap="small">
              {!hideOwner && (
                <>
                  <div data-testid="embed-topbar-avatar">
                    <Tooltip content={ownerName} placement="bottomCenter">
                      <UserAvatar
                        avatarSize={3}
                        avatarSrc={avatar && getCloudfrontURI(avatar)}
                        name="author"
                      />
                    </Tooltip>
                  </div>
                </>
              )}
              {!hideTitle && (
                <div className={styles.titleWrapper}>
                  <Text
                    onClick={titleClick}
                    hasEllipsis
                    size="large"
                    fontWeight="medium"
                  >
                    {video.name}
                  </Text>
                </div>
              )}
              {hideTitle && !hideOwner && (
                <Text hasEllipsis size="large" fontWeight="medium">
                  {limitTo20Characters(ownerName)}
                </Text>
              )}
            </Arrange>
          </Container>
          <Spacer top="xsmall" />
          <Container
            paddingX="small"
            radius="medium"
            backgroundColor="var(--videoOverlay)"
            width="max-content"
          >
            <Arrange gap="small" height={4}>
              <Arrange gap="xsmall">
                <Icon
                  data-testid="embed-topbar-duration-icon"
                  color="grey1"
                  icon={<SvgClock />}
                />
                <Text>{secondsToHumanReadableString(duration)}</Text>
              </Arrange>
              {showViews && (
                <Arrange gap="xsmall">
                  <Icon
                    data-testid="embed-topbar-views-icon"
                    color="grey1"
                    icon={<SvgEye />}
                  />
                  <Text>
                    {viewCount} {pluralize('view', viewCount)}
                  </Text>
                </Arrange>
              )}
            </Arrange>
          </Container>
        </div>
      )}
    </EmbedContext.Consumer>
  );
};

export default EmbedTitleAuthor;
